export const GNAV = {
  init: function () {
    const $body = $('body')
    const $switch = $('.js-gnav-switch')
    const openClass = 'is-gnav-open'

    if (!$switch.length) return

    // ハンバーガー開閉
    $switch.on('click', function (e) {
      e.preventDefault()
      e.stopPropagation()
      $body.toggleClass(openClass)
    })

    // メニュー内クリックは閉じない
    $('.l-header__nav').on('click', function (e) {
      e.stopPropagation()
    })

    // 画面どこでもクリックで閉じる
    $(document).on('click', function () {
      $body.removeClass(openClass)
    })

    // メニューリンク押したら閉じる（遷移前に）
    $('.l-header__nav a').on('click', function () {
      $body.removeClass(openClass)
    })
  },
}
